// import { Injectable } from '@angular/core';
// import { Observable, throwError } from 'rxjs';
// import { catchError } from 'rxjs/operators';

// @Injectable({
//   providedIn: 'root',
// })
// export class ErrorHandlerService {
//   handleError<T>() {
//     return (source: Observable<T>): Observable<T> => {
//       return source.pipe(
//         catchError((error: any) => {
//           if (error.status && error.message) {
//             return throwError(() => ({
//               statusCode: error.status,
//               errorMessage: error.error.message
//             }));
//           } else {
//             return throwError(() => ({
//               statusCode: 0,
//               errorMessage: 'An unexpected error occurred.'
//             }));
//           }
//         })
//       );
//     };
//   }
// }

import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  handleError<T>() {
    return (source: Observable<T>): Observable<T> => {
      return source.pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMessage = 'An unexpected error occurred.';
          let statusCode = error.status || 0;

          // Check if the error is an instance of HttpErrorResponse
          if (error instanceof HttpErrorResponse) {
            // Extract the error message from the backend response
            if (error.error && error.error.message) {
              errorMessage = error.error.message;
            } else if (error.message) {
              errorMessage = error.message;
            }
          }

          console.error('HTTP Error:', error); // Log the error for debugging

          // Return a custom error object
          return throwError(() => ({
            statusCode,
            errorMessage,
          }));
        })
      );
    };
  }
}